import { QueovalDik } from '../global';

export class BlockTree {
  public Value: string;
  public Text: string;
  public Params: string;
  public CollapseMode: number;
  public IsAllowed: boolean;
  public IsChecked: boolean;
  public IsVisible: boolean;
  public Children: Array<BlockTree>;
  public Files: Array<BlockFile>;
  public pipeRefresher: string
}
export class BlockFile {
  public key: string;
  public value: string;
  public fileName: string;
  public extension: string;
  public selected: boolean;
  public isWebLink: boolean;
  public group: string;
  public type: string;
  public infoTooltip: string;
  constructor() {
    this.selected = false;
  }
}
